import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../store/hooks"
import { selectIsOperatorConnected } from "../store/userOperator/selectors"
import { selectAuthStatus, selectLogoutState } from "../store/auth/selectors"
import { subscribeOnUsersData } from "../store/userOperator/thunks"
import { selectNewsState } from "../store/notifications/selectors"
import { getNotificationNews } from "../store/notifications/thunks"

export const useUserInitialization = () => {
    const isConnected = useAppSelector(selectIsOperatorConnected)
    const logoutState = useAppSelector(selectLogoutState)
    const authenticated = useAppSelector(selectAuthStatus)
    const userNewsState = useAppSelector(selectNewsState)
    const dispatch = useAppDispatch()
    useEffect(() => {
        if (authenticated && !userNewsState.data) {
            dispatch(getNotificationNews())
        }
    }, [authenticated, dispatch, userNewsState.data])
    useEffect(() => {
        if (authenticated && !isConnected && !logoutState.inProcess && userNewsState.data) {
            dispatch(subscribeOnUsersData())
        }
    }, [authenticated, dispatch, isConnected, logoutState.inProcess, userNewsState.data])
    return { isConnected, authenticated }
}
